"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var OptionsForm_1 = require("./OptionsForm");
var owa_options_store_1 = require("owa-options-store");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var ReactDOM = require("react-dom");
var styles = require('./OptionsFull.scss');
var OptionsPane = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPane, _super);
    function OptionsPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.optionFormRefs = {};
        return _this;
    }
    OptionsPane.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (ref) { return (_this.settingsForm = ref); }, className: styles.settingsForm }, this.props.options.map(function (option) { return (React.createElement(OptionsForm_1.default, { option: option, key: option.key, ref: function (ref) { return (_this.optionFormRefs[option.key] = ref); } })); })));
    };
    OptionsPane.prototype.componentDidMount = function () {
        this.scrollToSelectedOption();
    };
    OptionsPane.prototype.componentDidUpdate = function (prevProps) {
        if (this.props !== prevProps) {
            // We changed options, so reset the scroll position
            this.scrollToSelectedOption();
        }
    };
    OptionsPane.prototype.scrollToSelectedOption = function () {
        var selectedOption;
        var currentOptionKey = owa_options_store_1.getStore().currentOptionKey;
        if (currentOptionKey && (selectedOption = this.optionFormRefs[currentOptionKey])) {
            this.settingsForm.scrollTop = ReactDOM.findDOMNode(selectedOption).offsetTop;
        }
        else {
            this.settingsForm.scrollTop = 0;
        }
    };
    OptionsPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionsPane);
    return OptionsPane;
}(React.Component));
exports.default = OptionsPane;
//# sourceMappingURL=OptionsPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/OptionsPane.js
// module id = 5302
// module chunks = 2